import Vue from "vue";
import App from "./App.vue";

// router
import router from "./router";

// element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/reset.css'
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/ru-RU';
Vue.use(ElementUI, { locale });

import VueDataTables from 'vue-data-tables'
Vue.use(VueDataTables)

// store
import store from './store.js';

var _ = require('lodash');

var app = new Vue({ 
  router,
  store,
  render: h => h(App)
}).$mount('#app');

Vue.config.devtools = false;
Vue.config.productionTip = false;


